import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

export const trackDownloadAppClick = (
  e: React.MouseEvent | React.MouseEvent<HTMLAnchorElement>,
) => {
  const { href, title } = e.currentTarget as HTMLAnchorElement;

  sendGALinkClickEvent(e, {
    event: 'custom_event',
    event_category: 'App landing page',
    event_action: 'CTA Click',
    event_label: title,
    destination_URL: href,
  });
};
